var AbstractPlayerView    = require("./AbstractPlayerView"),
    IconButton            = require("app/ui/IconButton"),
    Image                 = require("app/ui/Image"),
    ImageOptimizerSupport = require("app/ui/ImageOptimizerSupport"),
    Layout                = require("./AudioViewLayout"),
    PlayPauseButton       = require("app/MediaPlayer/PlayPauseButton"),
    PrevNextButton        = require("app/MediaPlayer/PrevNextButton"),
    ResizeSensorSupport   = require("enyo-ui/ResizeSensorSupport"),
    Signals               = require("enyo/Signals"),
    ThumbnailVariables    = require("app/theme/styles/thumbnails/ThumbnailVariables"),
    ViewContainerSupport  = require("app/core/ViewContainerSupport"),
    findBestFittingCover  = require("app/utils/findBestFittingCover"),
    get                   = require("object-path").get,
    icons                 = require("app/theme/icons"),
    kind                  = require("enyo/kind"),
    onHyperlinkTap        = require("app/utils/onHyperlinkTap");

require("./AudioView.less");

module.exports = kind(/** @lends  app.MediaPlayer.AudioView.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.AudioView",

    /**
     * @private
     */
    kind: AbstractPlayerView,

    /**
     * @private
     */
    mixins: [
        ResizeSensorSupport
    ],

    /**
     * @private
     */
    classes: "app-media-player-audio-view",

    /**
     * @private
     */
    layoutKind: Layout,

    /**
     * @private
     */
    isReusable: true,

    /**
     * @private
     */
    components: [{
        classes: "app-media-player-audio-view__controls-background"
    }, {
        name:       "thumbnailContainer",
        classes:    "app-media-player-audio-view__thumbnail-container",
        components: [{
            name:       "thumbnailBlurred",
            kind:       Image,
            mixins:     [ImageOptimizerSupport],
            classes:    "app-media-player-audio-view__thumbnail-blurred",
            sizing:     "cover",
            attributes: {
                loading:  "eager",
                decoding: "async"
            }
        }, {
            name:       "thumbnail",
            kind:       Image,
            mixins:     [ImageOptimizerSupport],
            classes:    "app-media-player-audio-view__thumbnail",
            sizing:     "cover",
            attributes: {
                loading:  "eager",
                decoding: "async"
            }
        }]
    }, {
        name:    "expandButton",
        kind:    IconButton,
        classes: "app-media-player-audio-view__expand-button",
        icon:    icons["app.MediaPlayer.AudioView.expandButton"],
        ontap:   "onExpandButtonTap"
    }, {
        name:    "backButton",
        kind:    IconButton,
        classes: "app-media-player-audio-view__back-button",
        icon:    icons["app.MediaPlayer.AudioView.backButton"],
        ontap:   "onBackButtonTap"
    }, {
        name:       "metadata",
        classes:    "app-media-player-audio-view__metadata",
        components: [{
            name:    "title",
            classes: "app-media-player-audio-view__title"
        }, {
            name:    "secondaryTitle",
            classes: "app-media-player-audio-view__secondary-title"
        }]
    }, {
        name:      "prevMediaButton",
        kind:      PrevNextButton,
        classes:   "app-media-player-audio-view__prev-media-button",
        direction: "prev"
    }, {
        name:      "nextMediaButton",
        kind:      PrevNextButton,
        classes:   "app-media-player-audio-view__next-media-button",
        direction: "next"
    }, {
        name:    "playPauseButton",
        kind:    PlayPauseButton,
        classes: "app-media-player-audio-view__play-pause-button"
    }, {
        name:    "playerContainer",
        classes: "app-media-player-audio-view__player-container",
        mixins:  [ViewContainerSupport]
    }, {
        name:    "closeButton",
        kind:    IconButton,
        classes: "app-media-player-audio-view__close-button",
        icon:    icons["app.MediaPlayer.AudioView.closeButton"],
        ontap:   "closePlayer"
    }],

    /**
     * @private
     */
    handlers: {
        onNodeResized: "onNodeResized"
    },

    /**
     * @protected
     */
    update: function() {
        var $i18nService            = this.app.$.i18nService,
            $watchingSessionService = this.app.$.watchingSessionService,
            state                   = this.state || {},
            media                   = get(state, "media", null),
            asset                   = get(state, "asset", false),
            watchingSession         = get($watchingSessionService, "session", false),
            prevMedia               = get(state, "prevMedia", null),
            prevMediaType           = get(state, "prevMedia.type", null),
            nextMedia               = get(state, "nextMedia", null),
            nextMediaType           = get(state, "nextMedia.type", null),
            thumbnail               = findBestFittingCover(
                media || {},
                ThumbnailVariables.getAspectRatio("square")
            ),
            $player                 = this.getPlayerTech(),
            $prevMediaButton        = this.$.prevMediaButton,
            $nextMediaButton        = this.$.nextMediaButton;

        this.$.thumbnailBlurred.set("rawImageSrc", thumbnail ? {
            width:  thumbnail.width || null,
            height: thumbnail.height || null,
            ratio:  thumbnail.aspect_ratio || null,
            src:    get(thumbnail, "url", null)
        } : null);
        this.$.thumbnail.set("rawImageSrc", thumbnail ? {
            width:  thumbnail.width || null,
            height: thumbnail.height || null,
            ratio:  thumbnail.aspect_ratio || null,
            src:    get(thumbnail, "url", null)
        } : null);

        this.$.title.set("content", get(state, "media.meta.title", null) || "");
        this.$.secondaryTitle.set("content", get(state, "media.meta.secondary_title", null) || "");

        if (prevMedia) {
            $prevMediaButton.set("mediaItem", prevMedia);
            $prevMediaButton.set("tooltip", $i18nService.getString("app.MediaPlayer.AudioView.prevMediaButton.tooltip", {
                mediaType: prevMediaType || ""
            }));
        }
        else {
            $prevMediaButton.set("mediaItem", null);
            $prevMediaButton.set("tooltip", "");
        }

        if (nextMedia) {
            $nextMediaButton.set("mediaItem", nextMedia);
            $nextMediaButton.set("tooltip", $i18nService.getString("app.MediaPlayer.AudioView.nextMediaButton.tooltip", {
                mediaType: nextMediaType || ""
            }));
        }
        else {
            $nextMediaButton.set("mediaItem", null);
            $nextMediaButton.set("tooltip", "");
        }

        this.$.playPauseButton.set("mediaItem", media);

        if ($player) {
            if (media && asset && watchingSession) {
                $player.set("state", state);
            }
            else {
                $player && $player.set("state", null);
            }
        }

        this.resize();
    },

    /**
     * Verify displayMode support
     *
     * @param    {string}   displayMode  The display mode
     * @returns  {boolean}  Whether the display mode is supported
     * @public
     */
    supportsDisplayMode: function(displayMode) {
        return ["maximized", "footer", "minimized"].includes(displayMode);
    },

    // Player Tech
    // --------------------------------

    /**
     * Mounts the player tech in the player view.
     *
     * @param  {enyo.Control}  playerTech  The player tech
     * @public
     */
    mountPlayerTech: function(playerTech) {
        this.$.playerContainer.mountView(playerTech);
        this.resize();
    },

    /**
     * Unmounts the player tech in the player view.
     *
     * @param  {enyo.Control}  playerTech  The player tech
     * @public
     */
    unmountPlayerTech: function(playerTech) {
        this.$.playerContainer.unmountView(playerTech);
        this.resize();
    },

    /**
     * Get the mounted player tech.
     *
     * @returns  {?enyo.Control}  The player tech instance if available, `null`
     *                            otherwise.
     * @public
     */
    getPlayerTech: function() {
        return this.$.playerContainer.view || null;
    },

    // Resize Sensor
    // --------------------------------

    /**
     * @private
     */
    beforeUnmount: function() {
        this.detachResizeSensor();
    },

    /**
     * @private
     */
    afterMount: function() {
        this.attachResizeSensor();
    },

    /**
     * Respond to resize events.
     *
     * @returns  {boolean}  No further bubbling needed if it's one of our own
     *                      events.
     * @private
     */
    onNodeResized: function() {
        var bounds = this.getBounds();

        Signals.send("onMediaPlayerResized", {
            bounds: bounds
        });

        return true;
    },

    // Event Handlers
    // --------------------------------

    /**
     * Expand player
     */
    onExpandButtonTap: function() {
        var state  = this.state || {},
            router = this.app.$.router,
            media  = get(state, "media", {});

        switch (this.controller.get("displayMode")) {
            case "minimized":
                router.navigate(media.links.player);
                break;
            case "footer":
                router.navigate(media.links.expandedPlayer);
                break;
            case "maximized":
            default:
                break;
        }
    },

    /**
     * Instruct the router to navigate to the previous location
     *
     * @return  {boolean}  Stop propagation
     * @private
     */
    onBackButtonTap: function() {
        this.app.$.router.back(true);

        return true;
    },

    /**
     * Responds to a click on a hyperlink.
     *
     * @return  {boolean}  Stop propagation
     * @private
     */
    onHyperlinkTap: onHyperlinkTap,

    /**
     * Instruct the app to close the media player.
     *
     * @private
     */
    closePlayer: function() {
        this.app.$.mediaPlayerManager.deactivateMediaPlayer();
    }

});
